// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-main {
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
}
.home-main .home-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: 1;
}
.home-main .main-title {
  display: flex;
  width: 100%;
  padding-top: 100px;
  position: relative;
  z-index: 4;
  align-items: flex-start;
  justify-content: center;
}
.home-main .main-title h2 {
  font-size: 120px;
  line-height: 120%;
  font-weight: 700;
  color: white;
}

.main-home-part{
  padding: 30px 30px 100px 30px;
  height: 100vh;
  overflow-y: auto;
}
.head-data h6{
  font-size: 17px;
  font-weight: 400;
  color: #ADADAD;
}
.head-data h5{
  font-size: 17px;
  font-weight: 500;
  color: #1D2432;
}
.slider-part{
  margin-top: 15px;
}
.slider-title-block{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.slider-title-block .slider-title{
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 0;
}
.slider-title-block  a{
  font-size: 14px;
  font-weight: 500;
  color: #FF6036;
  text-decoration: none;
  padding-right: 30px;
}

.accordion-item{
  border-bottom: 1px solid #dee2e6;
  border-top: none !important;
  border-left:none !important;
  border-right: none !important;
  padding: 5px ;

}
.accordion-button:focus {
  z-index: 3;
  border-color: none !important;
  outline: 0;
  box-shadow:none !important;
}

.accordion-button{
  font-size: 20px !important;
  font-weight: 400;
}

.accordion-button:not(.collapsed){
  background-color: #cfe2ff00 !important;
  color: #212529 !important;
  box-shadow:none !important
}


.foot-page .accordion .nav.nav-pills .nav-link {
  font-weight: 400;
}

iframe{
  border-radius: 14px;
}

.exerciseLabfont {
  font-size: 14px;
}
.exerciseLabfontSUB{
  font-size: 14px;
}
.divi{
  display:flex;
}
.divi .divider {
  width: 100% !important;
  height: 1px !important;
  background-color: #d5d3d3 ;
}

.center-div
{
  position: absolute;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 100;
  width: 150px;
  height: 100px;
  background-color: #ffffff;
  box-shadow: 0px 1px 15px #0000000f;
  border-radius: 3px;
}
.nav-link.active{
  background-color: #ffffff !important;
}



.modal-sidebar > .modal-dialog {
  margin-right:0  ;
margin-top:0 ;


margin-bottom: 0;


}
.modal-sidebar > .modal-dialog > .modal-content{
  min-height: 100vh;
  overflow-y: scroll;
}
.modal-sidebar > .modal-dialog > .modal-content > .modal-header {
  justify-content: left;
}




.session-card-content {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.session-card-content .session-card {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  border-radius: 20px;
  background-color: #fff;
  position: relative;
}
.session-card-content .session-card.heart {
  /* background-color: #f4e6ff; */
  box-shadow: 0px 1px 15px #0000000f;
}
.session-card-content .session-card.arm {
  /* background-color: #E8F3E8; */
  box-shadow: 0px 1px 15px #0000000f;
}
.session-card-content .session-card.shoulder {
  /* background-color: #FFE3D9; */
  box-shadow: 0px 1px 15px #0000000f;
}
.session-card .details {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  justify-content: center;
  padding: 15px 10px;
}
.session-card .details h6.session-title {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
}
.session-card .details p.workout-text {
  font-size: 14px;
  font-weight: 400;
  color: #ADADAD;
}
.session-card .details .start-btn {
  all: unset;
  cursor: pointer;
  background-color: #fff;
  font-size: 15px;
  font-weight: 400;
  padding: 8px 20px;
  border-radius: 14px;
}
.session-card-content .session-card .image-block {
  display: flex;
  position: absolute;
  right: 20px;
}
.session-card-content .session-card .image-block img {
  height: 100%;
}

.main-content-part.excersiceList .exercise-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 10px 40px;
}

.preloader-whirlpool > span {
  position: fixed;
  top:60%;
  width:20rem;
  left: 60%;
  transform: translate(-50%, 100%);

}
.preloader-whirlpool {
  position: fixed;
  top: 50%;
  left: 60%;
  transform: translate(-50%, -50%);
  z-index: 9999; /* Ensure it's above other content */}

  .preloader-whirlpoolmodal {
    position: fixed;
    top: 50%;
    left: 50% !important;
    transform: translate(-50%, -50%);
    z-index: 9999; /* Ensure it's above other content */}
.preloader-whirlpool .whirlpool {
  position: absolute;
  top: 50%;
  left: 50%;
  border: 1px solid #ccc;
  border-left-color: #000;
  border-radius: 974px;
  -o-border-radius: 974px;
  -ms-border-radius: 974px;
  -webkit-border-radius: 974px;
  -moz-border-radius: 974px;
  margin: -24px 0 0 -24px;
  height: 49px;
  width: 49px;
  animation: cssload-rotate 1150ms linear infinite;
  -o-animation: cssload-rotate 1150ms linear infinite;
  -ms-animation: cssload-rotate 1150ms linear infinite;
  -webkit-animation: cssload-rotate 1150ms linear infinite;
  -moz-animation: cssload-rotate 1150ms linear infinite;
}
.preloader-whirlpool .whirlpool::before, .preloader-whirlpool .whirlpool::after {
  position: absolute;
  top: 50%;
  left: 50%;
  border: 1px solid #ccc;
  border-left-color: #000;
  border-radius: 974px;
  -o-border-radius: 974px;
  -ms-border-radius: 974px;
  -webkit-border-radius: 974px;
  -moz-border-radius: 974px;
}
.preloader-whirlpool .whirlpool::before {
  content: "";
  margin: -22px 0 0 -22px;
  height: 43px;
  width: 43px;
  animation: cssload-rotate 1150ms linear infinite;
  -o-animation: cssload-rotate 1150ms linear infinite;
  -ms-animation: cssload-rotate 1150ms linear infinite;
  -webkit-animation: cssload-rotate 1150ms linear infinite;
  -moz-animation: cssload-rotate 1150ms linear infinite;
}
.preloader-whirlpool .whirlpool::after {
  content: "";
  margin: -28px 0 0 -28px;
  height: 55px;
  width: 55px;
  animation: cssload-rotate 2300ms linear infinite;
  -o-animation: cssload-rotate 2300ms linear infinite;
  -ms-animation: cssload-rotate 2300ms linear infinite;
  -webkit-animation: cssload-rotate 2300ms linear infinite;
  -moz-animation: cssload-rotate 2300ms linear infinite;
}
@keyframes cssload-rotate {
  100% {
    transform: rotate(360deg);
 }
}


.field-error {
  border: 2px solid red !important;
  outline: none !important;
  box-shadow:  0 0 0.25rem rgba(13,110,253,.25)
}
.field-error:focus  , .field-error > .form-control:focus{
  box-shadow: 0 0 5px rgba(255, 0, 0, 0.667) !important;  /* Add a box shadow for more emphasis */

}
.modal-content-p0 > .modal-dialog > .modal-content{
  padding: 0 !important;
}
.withoutBorder {
   border: none !important;
}

.withoutBorder > .btn-close  {
  right: -26px !important;
  top: 13px;

}


 /* The outer-div to move the elements */
 .box-video{
  position: relative;
  width: 100%;
  margin:0 auto 20px auto;
  cursor: pointer;
  overflow: hidden;
}

 /* Set Cover aka Background-Image */
.box-video .bg-video{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  z-index: 2;
}

 /* Add light shade to make play button visible*/
.bg-video::after{ 
	content:'';
	position: absolute;
  	top: 0;
  	left: 0;
  	width: 100%;
  	height: 100%;
  	/* background-color: rgba(0,0,0,0.1); */
  	z-index: 3;
  	}


/* The Play-Button using CSS-Only */
.box-video .bt-play {
  position: absolute;
  top:50%;
  left:50%;
  margin:-30px 0 0 -30px;
  display: inline-block;
  width: 60px;
  height: 60px;
  background: rgba(255,255,255);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 50%;
  text-indent: -999em;
  cursor: pointer;
  z-index:2;
  transition: all .3s ease-out;
}

/* The Play-Triangle */
.box-video .bt-play:after {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  height: 0;
  width: 0;
  margin: -12px 0 0 -6px;
  border: solid transparent;
  border-left-color: #000;
  border-width: 12px 20px;
  transition: all .3s ease-out;
}

.box-video:hover .bt-play {
  transform: scale(1.1);
}

/* When Class added the Cover gets hidden... */
.box-video.open .bg-video{
  visibility: hidden;
  opacity: 0;
  transition: all .6s .8s;  
}

/* and iframe shows up */
.box-video.open .video-container{
  opacity: 1;
  transition: all .6s .8s;
}

/* Giving the div ratio of 16:9 with padding */
.video-container {
	position: relative;
	width: 100%;
	height: 0;
  margin: 0;
  z-index: 1;
	padding-bottom: 56.27198%;
}

.video-container video {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
  border-radius: 5%;
}
.center-div{
  z-index: 100;
}



/* community-card */
.community-card{
  border-radius: 14px;
  filter: drop-shadow(0 0 8.5px rgba(0,0,0,0.06));
  background-color: #ffffff;
}
.community-card .image-part img{
  width: 100%;
}
.community-card .text-part{
  padding: 15px;
}
.community-card .like-comment-data{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.community-card .like-commnet-icon img{
  width: 16px;
}
.community-card .like-comment-text{
  display: flex;
}
.community-card .text-part .img-date-part{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.community-card .text-part .img-date-part .prodile-img-name{
  display: flex;
  align-items: center;
  gap: 5px;
}
.community-card .text-part .img-date-part .prodile-img-name > img{
  border-radius: 14px;
}

.community-card .text-part p{
  margin-bottom: 0;
  font-size: 12px;
}
.community-card .text-part h6{
  font-size: 16px;
  line-height: 26px;
  margin: 10px 0;
  font-weight: 400;
}
.community-card .gray{
  color: #ADADAD;
}
.like-person-list{
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.like-person-list .like-person{
  display: flex;
  align-items: center;
  gap: 18px;
  border-bottom: 1px solid #EAEAEA;
  padding: 12px 0;
}
.like-person-list .like-person:first-child{
  padding-top: 0;
}
.like-person-list .like-person p{
  margin-bottom: 0;
  font-size: 16px;
}
.notification-card{
  border-radius: 14px;
  box-shadow: 0px 1px 15px #0000000f;
  padding: 20px;
  margin-bottom: 20px;
}
.notification-card h6{
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 4px;
}
.notification-card p{
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 10px;
  color: #ADADAD;
}
.notification-card p:last-child{
  margin-bottom: 6px;
}

.the-color{
  color : #FF6036 !important;
}

.selectedExeBtn{
  background-color: #ff6036cf !important;
  box-shadow: none;
  border-color: #FF6036;
  color: #fff;
  font-weight:600;
  padding: 14px;
}

.RichTextEditor__block___2Vs_D ,.RichTextEditor__paragraph___3NTf9{
  height: 40px;
  overflow: auto;
}
/* .title::first-letter,p::first-letter,
a::first-letter,
h1::first-letter,
h2::first-letter,
h3::first-letter,
h4::first-letter,
h5::first-letter,
h6::first-letter,
span::first-letter
 {
  text-transform: uppercase;
} */


.switch {
  position: relative;
  display: inline-block;
  width: 80px; /* Adjust width as needed */
  height: 40px; /* Adjust height as needed */
  border-radius: 34px;
  transition: background-color 0.2s;
  border: 1px solid #dee2e6;
  background-color: none;
 /* Default background */
}
.switch input {
  display: none;
}
.switch .slider {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  bottom: 0;
  transform: translateY(-50%);
  border-radius: 34px;
  cursor: pointer;
  transition: background-color 0.2s;
  background-color: rgba(128, 128, 128, 0) !important;
}
.switch .slider:before {
  content: "";
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  width: 40px; /* 50% of the switch width */
  height: 40px; /* Adjust as needed */
  background-color: #fbe3db;
  border-radius: 50%;
  transition: transform 0.2s;
}

input:checked + .slider {
  background-color: #2195f300; /* Color when switch is active */
}
input:checked + .slider:before {
  transform: translate(38px, -50%); /* Adjust this value to move the circle to the end of the switch */
}
.on-icon, .off-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  transition: opacity 0.2s;
  opacity: 1; /* Hide both icons by default */
}

.on-icon {
  right: 13px; /* Adjust as needed */
}
.off-icon {
  left: 13px; /* Adjust as needed */
}
input:checked ~ .on-icon {
  opacity: 1; /* Show on-icon when switch is checked */
}
input:not(:checked) ~ .off-icon {
  opacity: 1; /* Show off-icon when switch is not checked */
}
/* Styles for the on-icon and off-icon paths by default */
.on-icon > g > path,
.off-icon > g > path {
  transition: fill 0.2s ease-in-out; /* Smooth transition for color change */
}


/* Styles for the off-icon paths when the switch is unchecked */
.activeIcon > g > path {
  fill: gray !important; /* Fill color for off-icon paths when switch is unchecked */
}
.on-icon > g > path {
  fill: #FF6036;
}
.off-icon > g > path{
  fill: #FF6036;
}
/* Assuming 768px is the maximum width for mobile screens */
@media (max-width: 768px) {
  .theraphy-name > .serchPart {
    width: 100% !important;
  }
  
  .filterIcon {
    display: none; /* Hide the filter icon */
  }
}


.dropdown-component {
  display: inline-flex;
  border: 1px solid #CCC;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.dropdownSelect {
  border: none !important;
  padding: 15px 30px !important;
  appearance: none;
  background-color: transparent;
  cursor: pointer;
  font-weight: bold;
  outline: none;
}

.dropdownSelect:focus {
  outline: none !important;
  border: none !important;
  box-shadow: none !important;
}

.dropdown-label {
  background-color: #EEE;
  padding: 8px 16px;
  font-weight: 400;
  pointer-events: none;
  padding-top: 13px!important;
  padding-bottom: 13px!important;

}

/* For custom arrow */
.dropdownSelect::-ms-expand {
  display: none; /* Remove default arrow in IE */
}


.progress-bar{
   background-color: #FF6036 !important;
}
.ck-voice-label {
  display: none !important;
}
 .btn-outline-secondaryy{
  background-color: transparent;
  border-radius: 14px;
  border: 1px solid #eaeaea;
  font-size: 11px;
  padding:5px 10px;
}

.profile-image-doc {
  height: 200px;
  width: 200px;
  border-radius: 55%;
  object-fit: contain;
  background-color: #f0f0f0; /* Optional background color */
}

`, "",{"version":3,"sources":["webpack://./src/assets/css/home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,aAAa;;AAEf;AACA;EACE,UAAU;EACV,6BAA6B;EAC7B,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB;AACF;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,QAAQ;EACR,SAAS;EACT,SAAS;EACT,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,oCAAoC;AACtC;;;;AAIA;EACE,gBAAgB;AAClB,aAAa;;;AAGb,gBAAgB;;;AAGhB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;;;;;AAKA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,UAAU;EACV,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;AACtB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,WAAW;EACX,SAAS;EACT,gCAAgC;;AAElC;AACA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa,EAAE,oCAAoC,CAAC;;EAEpD;IACE,eAAe;IACf,QAAQ;IACR,oBAAoB;IACpB,gCAAgC;IAChC,aAAa,EAAE,oCAAoC,CAAC;AACxD;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,gDAAgD;EAChD,mDAAmD;EACnD,oDAAoD;EACpD,wDAAwD;EACxD,qDAAqD;AACvD;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,gDAAgD;EAChD,mDAAmD;EACnD,oDAAoD;EACpD,wDAAwD;EACxD,qDAAqD;AACvD;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,gDAAgD;EAChD,mDAAmD;EACnD,oDAAoD;EACpD,wDAAwD;EACxD,qDAAqD;AACvD;AACA;EACE;IACE,yBAAyB;CAC5B;AACD;;;AAuBA;EACE,gCAAgC;EAChC,wBAAwB;EACxB;AACF;AACA;EACE,qDAAqD,GAAG,uCAAuC;;AAEjG;AACA;EACE,qBAAqB;AACvB;AACA;GACG,uBAAuB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,SAAS;;AAEX;;;CAGC,uCAAuC;CACvC;EACC,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;CAEC,mCAAmC;AACpC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,UAAU;AACZ;;CAEC,+CAA+C;AAChD;CACC,UAAU;CACV,kBAAkB;GAChB,MAAM;GACN,OAAO;GACP,WAAW;GACX,YAAY;GACZ,uCAAuC;GACvC,UAAU;GACV;;;AAGH,mCAAmC;AACnC;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,mCAAmC;EACnC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,SAAS;EAET,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EAEvB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,UAAU;EAGV,uBAAuB;AACzB;;AAEA,wBAAwB;AACxB;EACE,UAAU;EAEV,uBAAuB;AACzB;;AAEA,8CAA8C;AAC9C;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;EACR,SAAS;EACT,UAAU;CACX,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;EACX,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;;;;AAIA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,+CAA+C;EAC/C,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;;;;;;;;;;;GAWG;;;AAGH;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW,EAAE,2BAA2B;EACxC,YAAY,EAAE,4BAA4B;EAC1C,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;EACzB,sBAAsB;CACvB,uBAAuB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,mDAAmD;AACrD;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,6BAA6B;EAC7B,WAAW,EAAE,4BAA4B;EACzC,YAAY,EAAE,qBAAqB;EACnC,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B,EAAE,gCAAgC;AAC/D;AACA;EACE,gCAAgC,EAAE,kEAAkE;AACtG;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;EACxB,UAAU,EAAE,+BAA+B;AAC7C;;AAEA;EACE,WAAW,EAAE,qBAAqB;AACpC;AACA;EACE,UAAU,EAAE,qBAAqB;AACnC;AACA;EACE,UAAU,EAAE,wCAAwC;AACtD;AACA;EACE,UAAU,EAAE,6CAA6C;AAC3D;AACA,yDAAyD;AACzD;;EAEE,iCAAiC,EAAE,uCAAuC;AAC5E;;;AAGA,+DAA+D;AAC/D;EACE,qBAAqB,EAAE,2DAA2D;AACpF;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA,2DAA2D;AAC3D;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa,EAAE,yBAAyB;EAC1C;AACF;;;AAGA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAG7B,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;EAC3B,8BAA8B;;AAEhC;;AAEA,qBAAqB;AACrB;EACE,aAAa,EAAE,+BAA+B;AAChD;;;AAGA;GACG,oCAAoC;AACvC;AACA;EACE,wBAAwB;AAC1B;CACC;EACC,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB,EAAE,8BAA8B;AAC3D","sourcesContent":[".home-main {\r\n  display: flex;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n.home-main .home-bg {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  object-position: center;\r\n  z-index: 1;\r\n}\r\n.home-main .main-title {\r\n  display: flex;\r\n  width: 100%;\r\n  padding-top: 100px;\r\n  position: relative;\r\n  z-index: 4;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n}\r\n.home-main .main-title h2 {\r\n  font-size: 120px;\r\n  line-height: 120%;\r\n  font-weight: 700;\r\n  color: white;\r\n}\r\n\r\n.main-home-part{\r\n  padding: 30px 30px 100px 30px;\r\n  height: 100vh;\r\n  overflow-y: auto;\r\n}\r\n.head-data h6{\r\n  font-size: 17px;\r\n  font-weight: 400;\r\n  color: #ADADAD;\r\n}\r\n.head-data h5{\r\n  font-size: 17px;\r\n  font-weight: 500;\r\n  color: #1D2432;\r\n}\r\n.slider-part{\r\n  margin-top: 15px;\r\n}\r\n.slider-title-block{\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n.slider-title-block .slider-title{\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  margin-bottom: 0;\r\n}\r\n.slider-title-block  a{\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: #FF6036;\r\n  text-decoration: none;\r\n  padding-right: 30px;\r\n}\r\n\r\n.accordion-item{\r\n  border-bottom: 1px solid #dee2e6;\r\n  border-top: none !important;\r\n  border-left:none !important;\r\n  border-right: none !important;\r\n  padding: 5px ;\r\n\r\n}\r\n.accordion-button:focus {\r\n  z-index: 3;\r\n  border-color: none !important;\r\n  outline: 0;\r\n  box-shadow:none !important;\r\n}\r\n\r\n.accordion-button{\r\n  font-size: 20px !important;\r\n  font-weight: 400;\r\n}\r\n\r\n.accordion-button:not(.collapsed){\r\n  background-color: #cfe2ff00 !important;\r\n  color: #212529 !important;\r\n  box-shadow:none !important\r\n}\r\n\r\n\r\n.foot-page .accordion .nav.nav-pills .nav-link {\r\n  font-weight: 400;\r\n}\r\n\r\niframe{\r\n  border-radius: 14px;\r\n}\r\n\r\n.exerciseLabfont {\r\n  font-size: 14px;\r\n}\r\n.exerciseLabfontSUB{\r\n  font-size: 14px;\r\n}\r\n.divi{\r\n  display:flex;\r\n}\r\n.divi .divider {\r\n  width: 100% !important;\r\n  height: 1px !important;\r\n  background-color: #d5d3d3 ;\r\n}\r\n\r\n.center-div\r\n{\r\n  position: absolute;\r\n  margin: auto;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 100;\r\n  width: 150px;\r\n  height: 100px;\r\n  background-color: #ffffff;\r\n  box-shadow: 0px 1px 15px #0000000f;\r\n  border-radius: 3px;\r\n}\r\n.nav-link.active{\r\n  background-color: #ffffff !important;\r\n}\r\n\r\n\r\n\r\n.modal-sidebar > .modal-dialog {\r\n  margin-right:0  ;\r\nmargin-top:0 ;\r\n\r\n\r\nmargin-bottom: 0;\r\n\r\n\r\n}\r\n.modal-sidebar > .modal-dialog > .modal-content{\r\n  min-height: 100vh;\r\n  overflow-y: scroll;\r\n}\r\n.modal-sidebar > .modal-dialog > .modal-content > .modal-header {\r\n  justify-content: left;\r\n}\r\n\r\n\r\n\r\n\r\n.session-card-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 30px;\r\n}\r\n.session-card-content .session-card {\r\n  display: flex;\r\n  width: 100%;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 0 20px;\r\n  border-radius: 20px;\r\n  background-color: #fff;\r\n  position: relative;\r\n}\r\n.session-card-content .session-card.heart {\r\n  /* background-color: #f4e6ff; */\r\n  box-shadow: 0px 1px 15px #0000000f;\r\n}\r\n.session-card-content .session-card.arm {\r\n  /* background-color: #E8F3E8; */\r\n  box-shadow: 0px 1px 15px #0000000f;\r\n}\r\n.session-card-content .session-card.shoulder {\r\n  /* background-color: #FFE3D9; */\r\n  box-shadow: 0px 1px 15px #0000000f;\r\n}\r\n.session-card .details {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n  padding: 15px 10px;\r\n}\r\n.session-card .details h6.session-title {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n}\r\n.session-card .details p.workout-text {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  color: #ADADAD;\r\n}\r\n.session-card .details .start-btn {\r\n  all: unset;\r\n  cursor: pointer;\r\n  background-color: #fff;\r\n  font-size: 15px;\r\n  font-weight: 400;\r\n  padding: 8px 20px;\r\n  border-radius: 14px;\r\n}\r\n.session-card-content .session-card .image-block {\r\n  display: flex;\r\n  position: absolute;\r\n  right: 20px;\r\n}\r\n.session-card-content .session-card .image-block img {\r\n  height: 100%;\r\n}\r\n\r\n.main-content-part.excersiceList .exercise-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    padding: 10px 40px;\r\n}\r\n\r\n.preloader-whirlpool > span {\r\n  position: fixed;\r\n  top:60%;\r\n  width:20rem;\r\n  left: 60%;\r\n  transform: translate(-50%, 100%);\r\n\r\n}\r\n.preloader-whirlpool {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 60%;\r\n  transform: translate(-50%, -50%);\r\n  z-index: 9999; /* Ensure it's above other content */}\r\n\r\n  .preloader-whirlpoolmodal {\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50% !important;\r\n    transform: translate(-50%, -50%);\r\n    z-index: 9999; /* Ensure it's above other content */}\r\n.preloader-whirlpool .whirlpool {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  border: 1px solid #ccc;\r\n  border-left-color: #000;\r\n  border-radius: 974px;\r\n  -o-border-radius: 974px;\r\n  -ms-border-radius: 974px;\r\n  -webkit-border-radius: 974px;\r\n  -moz-border-radius: 974px;\r\n  margin: -24px 0 0 -24px;\r\n  height: 49px;\r\n  width: 49px;\r\n  animation: cssload-rotate 1150ms linear infinite;\r\n  -o-animation: cssload-rotate 1150ms linear infinite;\r\n  -ms-animation: cssload-rotate 1150ms linear infinite;\r\n  -webkit-animation: cssload-rotate 1150ms linear infinite;\r\n  -moz-animation: cssload-rotate 1150ms linear infinite;\r\n}\r\n.preloader-whirlpool .whirlpool::before, .preloader-whirlpool .whirlpool::after {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  border: 1px solid #ccc;\r\n  border-left-color: #000;\r\n  border-radius: 974px;\r\n  -o-border-radius: 974px;\r\n  -ms-border-radius: 974px;\r\n  -webkit-border-radius: 974px;\r\n  -moz-border-radius: 974px;\r\n}\r\n.preloader-whirlpool .whirlpool::before {\r\n  content: \"\";\r\n  margin: -22px 0 0 -22px;\r\n  height: 43px;\r\n  width: 43px;\r\n  animation: cssload-rotate 1150ms linear infinite;\r\n  -o-animation: cssload-rotate 1150ms linear infinite;\r\n  -ms-animation: cssload-rotate 1150ms linear infinite;\r\n  -webkit-animation: cssload-rotate 1150ms linear infinite;\r\n  -moz-animation: cssload-rotate 1150ms linear infinite;\r\n}\r\n.preloader-whirlpool .whirlpool::after {\r\n  content: \"\";\r\n  margin: -28px 0 0 -28px;\r\n  height: 55px;\r\n  width: 55px;\r\n  animation: cssload-rotate 2300ms linear infinite;\r\n  -o-animation: cssload-rotate 2300ms linear infinite;\r\n  -ms-animation: cssload-rotate 2300ms linear infinite;\r\n  -webkit-animation: cssload-rotate 2300ms linear infinite;\r\n  -moz-animation: cssload-rotate 2300ms linear infinite;\r\n}\r\n@keyframes cssload-rotate {\r\n  100% {\r\n    transform: rotate(360deg);\r\n }\r\n}\r\n@-o-keyframes cssload-rotate {\r\n  100% {\r\n    -o-transform: rotate(360deg);\r\n }\r\n}\r\n@-ms-keyframes cssload-rotate {\r\n  100% {\r\n    -ms-transform: rotate(360deg);\r\n }\r\n}\r\n@-webkit-keyframes cssload-rotate {\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n }\r\n}\r\n@-moz-keyframes cssload-rotate {\r\n  100% {\r\n    -moz-transform: rotate(360deg);\r\n }\r\n}\r\n\r\n\r\n.field-error {\r\n  border: 2px solid red !important;\r\n  outline: none !important;\r\n  box-shadow:  0 0 0.25rem rgba(13,110,253,.25)\r\n}\r\n.field-error:focus  , .field-error > .form-control:focus{\r\n  box-shadow: 0 0 5px rgba(255, 0, 0, 0.667) !important;  /* Add a box shadow for more emphasis */\r\n\r\n}\r\n.modal-content-p0 > .modal-dialog > .modal-content{\r\n  padding: 0 !important;\r\n}\r\n.withoutBorder {\r\n   border: none !important;\r\n}\r\n\r\n.withoutBorder > .btn-close  {\r\n  right: -26px !important;\r\n  top: 13px;\r\n\r\n}\r\n\r\n\r\n /* The outer-div to move the elements */\r\n .box-video{\r\n  position: relative;\r\n  width: 100%;\r\n  margin:0 auto 20px auto;\r\n  cursor: pointer;\r\n  overflow: hidden;\r\n}\r\n\r\n /* Set Cover aka Background-Image */\r\n.box-video .bg-video{\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n  background-size: cover;\r\n  z-index: 2;\r\n}\r\n\r\n /* Add light shade to make play button visible*/\r\n.bg-video::after{ \r\n\tcontent:'';\r\n\tposition: absolute;\r\n  \ttop: 0;\r\n  \tleft: 0;\r\n  \twidth: 100%;\r\n  \theight: 100%;\r\n  \t/* background-color: rgba(0,0,0,0.1); */\r\n  \tz-index: 3;\r\n  \t}\r\n\r\n\r\n/* The Play-Button using CSS-Only */\r\n.box-video .bt-play {\r\n  position: absolute;\r\n  top:50%;\r\n  left:50%;\r\n  margin:-30px 0 0 -30px;\r\n  display: inline-block;\r\n  width: 60px;\r\n  height: 60px;\r\n  background: rgba(255,255,255);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  border-radius: 50%;\r\n  text-indent: -999em;\r\n  cursor: pointer;\r\n  z-index:2;\r\n  -webkit-transition: all .3s ease-out;\r\n  transition: all .3s ease-out;\r\n}\r\n\r\n/* The Play-Triangle */\r\n.box-video .bt-play:after {\r\n  content: '';\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 50%;\r\n  height: 0;\r\n  width: 0;\r\n  margin: -12px 0 0 -6px;\r\n  border: solid transparent;\r\n  border-left-color: #000;\r\n  border-width: 12px 20px;\r\n  -webkit-transition: all .3s ease-out;\r\n  transition: all .3s ease-out;\r\n}\r\n\r\n.box-video:hover .bt-play {\r\n  transform: scale(1.1);\r\n}\r\n\r\n/* When Class added the Cover gets hidden... */\r\n.box-video.open .bg-video{\r\n  visibility: hidden;\r\n  opacity: 0;\r\n\r\n  -webkit-transition: all .6s .8s;\r\n  transition: all .6s .8s;  \r\n}\r\n\r\n/* and iframe shows up */\r\n.box-video.open .video-container{\r\n  opacity: 1;\r\n  -webkit-transition: all .6s .8s;\r\n  transition: all .6s .8s;\r\n}\r\n\r\n/* Giving the div ratio of 16:9 with padding */\r\n.video-container {\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\theight: 0;\r\n  margin: 0;\r\n  z-index: 1;\r\n\tpadding-bottom: 56.27198%;\r\n}\r\n\r\n.video-container video {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n  border-radius: 5%;\r\n}\r\n.center-div{\r\n  z-index: 100;\r\n}\r\n\r\n\r\n\r\n/* community-card */\r\n.community-card{\r\n  border-radius: 14px;\r\n  filter: drop-shadow(0 0 8.5px rgba(0,0,0,0.06));\r\n  background-color: #ffffff;\r\n}\r\n.community-card .image-part img{\r\n  width: 100%;\r\n}\r\n.community-card .text-part{\r\n  padding: 15px;\r\n}\r\n.community-card .like-comment-data{\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n.community-card .like-commnet-icon img{\r\n  width: 16px;\r\n}\r\n.community-card .like-comment-text{\r\n  display: flex;\r\n}\r\n.community-card .text-part .img-date-part{\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n.community-card .text-part .img-date-part .prodile-img-name{\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n.community-card .text-part .img-date-part .prodile-img-name > img{\r\n  border-radius: 14px;\r\n}\r\n\r\n.community-card .text-part p{\r\n  margin-bottom: 0;\r\n  font-size: 12px;\r\n}\r\n.community-card .text-part h6{\r\n  font-size: 16px;\r\n  line-height: 26px;\r\n  margin: 10px 0;\r\n  font-weight: 400;\r\n}\r\n.community-card .gray{\r\n  color: #ADADAD;\r\n}\r\n.like-person-list{\r\n  list-style-type: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.like-person-list .like-person{\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 18px;\r\n  border-bottom: 1px solid #EAEAEA;\r\n  padding: 12px 0;\r\n}\r\n.like-person-list .like-person:first-child{\r\n  padding-top: 0;\r\n}\r\n.like-person-list .like-person p{\r\n  margin-bottom: 0;\r\n  font-size: 16px;\r\n}\r\n.notification-card{\r\n  border-radius: 14px;\r\n  box-shadow: 0px 1px 15px #0000000f;\r\n  padding: 20px;\r\n  margin-bottom: 20px;\r\n}\r\n.notification-card h6{\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  margin-bottom: 4px;\r\n}\r\n.notification-card p{\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  margin-bottom: 10px;\r\n  color: #ADADAD;\r\n}\r\n.notification-card p:last-child{\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.the-color{\r\n  color : #FF6036 !important;\r\n}\r\n\r\n.selectedExeBtn{\r\n  background-color: #ff6036cf !important;\r\n  box-shadow: none;\r\n  border-color: #FF6036;\r\n  color: #fff;\r\n  font-weight:600;\r\n  padding: 14px;\r\n}\r\n\r\n.RichTextEditor__block___2Vs_D ,.RichTextEditor__paragraph___3NTf9{\r\n  height: 40px;\r\n  overflow: auto;\r\n}\r\n/* .title::first-letter,p::first-letter,\r\na::first-letter,\r\nh1::first-letter,\r\nh2::first-letter,\r\nh3::first-letter,\r\nh4::first-letter,\r\nh5::first-letter,\r\nh6::first-letter,\r\nspan::first-letter\r\n {\r\n  text-transform: uppercase;\r\n} */\r\n\r\n\r\n.switch {\r\n  position: relative;\r\n  display: inline-block;\r\n  width: 80px; /* Adjust width as needed */\r\n  height: 40px; /* Adjust height as needed */\r\n  border-radius: 34px;\r\n  transition: background-color 0.2s;\r\n  border: 1px solid #dee2e6;\r\n  background-color: none;\r\n /* Default background */\r\n}\r\n.switch input {\r\n  display: none;\r\n}\r\n.switch .slider {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  transform: translateY(-50%);\r\n  border-radius: 34px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n  background-color: rgba(128, 128, 128, 0) !important;\r\n}\r\n.switch .slider:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translate(0, -50%);\r\n  width: 40px; /* 50% of the switch width */\r\n  height: 40px; /* Adjust as needed */\r\n  background-color: #fbe3db;\r\n  border-radius: 50%;\r\n  transition: transform 0.2s;\r\n}\r\n\r\ninput:checked + .slider {\r\n  background-color: #2195f300; /* Color when switch is active */\r\n}\r\ninput:checked + .slider:before {\r\n  transform: translate(38px, -50%); /* Adjust this value to move the circle to the end of the switch */\r\n}\r\n.on-icon, .off-icon {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  transition: opacity 0.2s;\r\n  opacity: 1; /* Hide both icons by default */\r\n}\r\n\r\n.on-icon {\r\n  right: 13px; /* Adjust as needed */\r\n}\r\n.off-icon {\r\n  left: 13px; /* Adjust as needed */\r\n}\r\ninput:checked ~ .on-icon {\r\n  opacity: 1; /* Show on-icon when switch is checked */\r\n}\r\ninput:not(:checked) ~ .off-icon {\r\n  opacity: 1; /* Show off-icon when switch is not checked */\r\n}\r\n/* Styles for the on-icon and off-icon paths by default */\r\n.on-icon > g > path,\r\n.off-icon > g > path {\r\n  transition: fill 0.2s ease-in-out; /* Smooth transition for color change */\r\n}\r\n\r\n\r\n/* Styles for the off-icon paths when the switch is unchecked */\r\n.activeIcon > g > path {\r\n  fill: gray !important; /* Fill color for off-icon paths when switch is unchecked */\r\n}\r\n.on-icon > g > path {\r\n  fill: #FF6036;\r\n}\r\n.off-icon > g > path{\r\n  fill: #FF6036;\r\n}\r\n/* Assuming 768px is the maximum width for mobile screens */\r\n@media (max-width: 768px) {\r\n  .theraphy-name > .serchPart {\r\n    width: 100% !important;\r\n  }\r\n  \r\n  .filterIcon {\r\n    display: none; /* Hide the filter icon */\r\n  }\r\n}\r\n\r\n\r\n.dropdown-component {\r\n  display: inline-flex;\r\n  border: 1px solid #CCC;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.dropdownSelect {\r\n  border: none !important;\r\n  padding: 15px 30px !important;\r\n  -moz-appearance: none;\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  background-color: transparent;\r\n  cursor: pointer;\r\n  font-weight: bold;\r\n  outline: none;\r\n}\r\n\r\n.dropdownSelect:focus {\r\n  outline: none !important;\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.dropdown-label {\r\n  background-color: #EEE;\r\n  padding: 8px 16px;\r\n  font-weight: 400;\r\n  pointer-events: none;\r\n  padding-top: 13px!important;\r\n  padding-bottom: 13px!important;\r\n\r\n}\r\n\r\n/* For custom arrow */\r\n.dropdownSelect::-ms-expand {\r\n  display: none; /* Remove default arrow in IE */\r\n}\r\n\r\n\r\n.progress-bar{\r\n   background-color: #FF6036 !important;\r\n}\r\n.ck-voice-label {\r\n  display: none !important;\r\n}\r\n .btn-outline-secondaryy{\r\n  background-color: transparent;\r\n  border-radius: 14px;\r\n  border: 1px solid #eaeaea;\r\n  font-size: 11px;\r\n  padding:5px 10px;\r\n}\r\n\r\n.profile-image-doc {\r\n  height: 200px;\r\n  width: 200px;\r\n  border-radius: 55%;\r\n  object-fit: contain;\r\n  background-color: #f0f0f0; /* Optional background color */\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
